import {
    api_url,
    legendLabelsBoxHeightLine,
    configChartsColorPalettes,
    yRight,
    partSumpTrajectory,
    popupInformation,
    defaultDatalabelsAlign,
    defaultDatalabelsAnchor,
    defaultDatalabelsFontWeight,
    defaultTicksCustomValue,
} from "../../../utils";

const DureeMoyenneTrajetCuscoChinchero = {
    checked: false,
    titleSideBar:
        "Tiempo promedio de viaje en transporte público y privado entre el centro de Cusco y Chinchero",
    titleIndicator:
        "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.title",
    popupInformation: {
        status: "false",
        text: popupInformation[partSumpTrajectory][
            "dureeMoyenneTrajetCuscoChinchero"
        ],
    },
    keyFigure: {
        typeUpdate: "geographical_area", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
    },
    charts: [
        {
            typeChart: "bar",
            typeLabels: "years", // years or geographical_areas
            multiYearGeographicalArea: true,
            singleYearGeographicalAreaType: "year", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
            titleChart: "",
            titleDisplay: "true",
            legendDisplay: "true",
            legendCustom: "false",
            legendLabelsBoxHeight: legendLabelsBoxHeightLine,
            maintainAspectRatio: true,
            indexAxis: "x", // x or y
            heightChart: "300",
            widthChart: "600",
            i18nKeyLabels:
                "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.axis.labelsX",
            scales: {
                x: {
                    type: "category",
                    display: true,
                    stacked: false,
                    titleDisplay: false,
                    titleText: "",
                    gridDisplay: false,
                    beginAtZero: false,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue,
                    },
                },
                y: {
                    type: "linear",
                    display: true,
                    stacked: false,
                    titleDisplay: true,
                    titleText:
                        "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.axis.titleY",
                    gridDisplay: true,
                    beginAtZero: true,
                    max: 80,
                    ticks: {
                        display: true,
                        value: {
                            prefix: "",
                            suffix: "",
                        },
                    },
                },
                yRight: yRight,
            },
            annotationsProperties: {
                annotation1: undefined,
                annotation2: undefined,
            },
            keyFigure: {
                typeUpdate: "geographical_area", // year or geographical_area
                label: "",
                url: "",
                separator: "",
                position: "",
            },
            datasets: [
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.legend.HIDETOOLTIPIFZERODurée moyenne du trajet en transport public",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=duree_moyenne_trajet_cusco_chinchero&trend=projection&chart=duree_moyenne_trajet_cusco_chinchero_transport_prive&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes[
                            "trajectory_duree_moyenne_trajet_cusco_chinchero"
                        ].backgroundColor["0"],
                    borderColor:
                        configChartsColorPalettes[
                            "trajectory_duree_moyenne_trajet_cusco_chinchero"
                        ].borderColor["0"],
                    borderWidth: 2,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    tooltipToReplace: {
                        "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.legend.HIDETOOLTIPIFZERODurée moyenne du trajet en transport public":
                            "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.legend.HIDETOOLTIPIFZERODurée moyenne du trajet en transport public Popup",
                    },
                    barPercentage: 1,
                    categoryPercentage: 1,
                    datalabelsProperties: {
                        display: true,
                        anchor: defaultDatalabelsAnchor,
                        align: defaultDatalabelsAlign,
                        font: {
                            weight: defaultDatalabelsFontWeight,
                        },
                        value: {
                            prefix: "",
                            suffix: "",
                            separator: "decimal",
                        },
                    },
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.legend.HIDETOOLTIPIFZERODurée moyenne du trajet en transport privé",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=duree_moyenne_trajet_cusco_chinchero&trend=projection&chart=duree_moyenne_trajet_cusco_chinchero_transport_public&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes[
                            "trajectory_duree_moyenne_trajet_cusco_chinchero"
                        ].backgroundColor["1"],
                    borderColor:
                        configChartsColorPalettes[
                            "trajectory_duree_moyenne_trajet_cusco_chinchero"
                        ].borderColor["1"],
                    borderWidth: 2,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    tooltipToReplace: {
                        "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.legend.HIDETOOLTIPIFZERODurée moyenne du trajet en transport privé":
                            "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.legend.HIDETOOLTIPIFZERODurée moyenne du trajet en transport privé Popup",
                    },
                    barPercentage: 1,
                    categoryPercentage: 1,
                    datalabelsProperties: {
                        display: true,
                        anchor: defaultDatalabelsAnchor,
                        align: defaultDatalabelsAlign,
                        font: {
                            weight: defaultDatalabelsFontWeight,
                        },
                        value: {
                            prefix: "",
                            suffix: "",
                            separator: "decimal",
                        },
                    },
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.legend.HIDELEGENDHIDETOOLTIPIFZERODurée moyenne du trajet en transport public",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=duree_moyenne_trajet_cusco_chinchero&trend=projection&chart=duree_moyenne_trajet_cusco_chinchero_transport_prive_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes[
                            "trajectory_duree_moyenne_trajet_cusco_chinchero_objective_transparency"
                        ].backgroundColor["0"],
                    borderColor:
                        configChartsColorPalettes[
                            "trajectory_duree_moyenne_trajet_cusco_chinchero_objective_transparency"
                        ].borderColor["0"],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    tooltipToReplace: {
                        "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.legend.HIDELEGENDHIDETOOLTIPIFZERODurée moyenne du trajet en transport public":
                            "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.legend.HIDELEGENDHIDETOOLTIPIFZERODurée moyenne du trajet en transport public Popup",
                    },
                    barPercentage: 1,
                    categoryPercentage: 1,
                    datalabelsProperties: {
                        display: true,
                        anchor: defaultDatalabelsAnchor,
                        align: defaultDatalabelsAlign,
                        font: {
                            weight: defaultDatalabelsFontWeight,
                        },
                        value: {
                            prefix: "",
                            suffix: "",
                            separator: "decimal",
                        },
                    },
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.legend.HIDELEGENDHIDETOOLTIPIFZERODurée moyenne du trajet en transport privé",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=duree_moyenne_trajet_cusco_chinchero&trend=projection&chart=duree_moyenne_trajet_cusco_chinchero_transport_public_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes[
                            "trajectory_duree_moyenne_trajet_cusco_chinchero_objective_transparency"
                        ].backgroundColor["1"],
                    borderColor:
                        configChartsColorPalettes[
                            "trajectory_duree_moyenne_trajet_cusco_chinchero_objective_transparency"
                        ].borderColor["1"],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    tooltipToReplace: {
                        "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.legend.HIDELEGENDHIDETOOLTIPIFZERODurée moyenne du trajet en transport privé":
                            "SUMP Trajectory Content.charts.DureeMoyenneTrajetCuscoChinchero.legend.HIDELEGENDHIDETOOLTIPIFZERODurée moyenne du trajet en transport privé Popup",
                    },
                    barPercentage: 1,
                    categoryPercentage: 1,
                    datalabelsProperties: {
                        display: true,
                        anchor: defaultDatalabelsAnchor,
                        align: defaultDatalabelsAlign,
                        font: {
                            weight: defaultDatalabelsFontWeight,
                        },
                        value: {
                            prefix: "",
                            suffix: "",
                            separator: "decimal",
                        },
                    },
                },
            ],
        },
    ],
};

export default DureeMoyenneTrajetCuscoChinchero;
